import { SelfServiceConfig } from '../services/selfservice-loader.service';


export const DEV_SELFSERVICE_CONFIGS: Record<string, SelfServiceConfig> = {
  userRegistration: {
    name: 'User Registration',
    remoteUrl: 'https://dmz21-digital-transformation-dev.s3.amazonaws.com/user-registration-2',
    rootElementId: 'selfservice-app-root',
    rootElementTag: 'app-root',
    scriptFiles: [
      'https://dmz21-digital-transformation-dev.s3.amazonaws.com/user-registration-2/runtime.js',
      'https://dmz21-digital-transformation-dev.s3.amazonaws.com/user-registration-2/polyfills.js',
      'https://dmz21-digital-transformation-dev.s3.amazonaws.com/user-registration-2/main.js',
    ],
    styleFiles: [
      'https://dmz21-digital-transformation-dev.s3.amazonaws.com/user-registration-2/styles.css',
    ],
  },
};
